<template src="./template.html"></template>

<script>
export default {
  name: "MainLoading",
  methods: {}
}
</script>